import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PrinterService } from '../printer/printer.service';
import { MessageBeep } from "../messageBeep/messageBeep.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class HasPrinterService  {

	constructor(
		private printerService: PrinterService,
		private router: Router,
		private beep: MessageBeep,
		private translate: TranslateService
	) {
		this.printerService = printerService;
		this.router = router;
		this.beep = beep;
		this.translate = translate;
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		// Store state url in localStorage for later redirect by callback component
		localStorage['redirectURL'] = state.url;

		switch (state.url) {
			case '/receiving':
				this.printerService.hasQuery().subscribe({
					next: {},
					error: () => {
						this.router.navigate(['inbound']);
					}
				});
				break;
			case '/dispatchingandinvoicing':
				this.printerService.hasQueryToPrint().subscribe({
					next: {},
					error: (err) => {
						this.beep.showAlertCustom("modal.error", 'modal.' + err.error.failureList[0].messageCode.split('.').pop());
						this.router.navigate(['outbound']);
					}
				});
				break;
		}


		return true;
	}
}
